export const PEELING_DONE_LIST_REQUEST = "PEELING_DONE_LIST_REQUEST";
export const PEELING_DONE_LIST_SUCCESS = "PEELING_DONE_LIST_SUCCESS";
export const PEELING_DONE_LIST_FAILED = "PEELING_DONE_LIST_FAILED";
